import { DOMOutputSpec, MarkSpec } from "prosemirror-model";

const underlineDOM: DOMOutputSpec = ["u", 0];

export const underline: MarkSpec = {
	parseDOM: [
		{tag: "u"},
		{style: "text-decoration=underline"},
		{style: "text-decoration-line: underline;"}
	],
	toDOM: () => underlineDOM
};
